import { render, staticRenderFns } from "./co-occurring-modal.vue?vue&type=template&id=222d135a&"
import script from "./co-occurring-modal.vue?vue&type=script&lang=js&"
export * from "./co-occurring-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports